import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-p-2"
}
const _hoisted_2 = {
  key: 1,
  class: "p-p-2 systemPromptContainer"
}
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid p-jc-end p-pt-2 p-px-2 buttonBar" }
const _hoisted_5 = { class: "p-field p-col-3" }
const _hoisted_6 = { class: "p-field p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.isSolutionClass)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Message, {
          severity: "info",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.SystemPromptNotForSolutionClasses')), 1)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_BlockUI, {
          blocked: _ctx.loading,
          class: "promptArea"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.SystemPromptDescription')), 1),
            _createVNode(_component_Editor, {
              id: "systemPrompt",
              class: "systemPromptEditor",
              placeholder: _ctx.$t('Squeeze.DocumentClasses.SystemPromptPlaceholder'),
              onLoad: _ctx.onEditorLoad,
              onTextChange: _ctx.onTextChange
            }, {
              toolbar: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "ql-formats" }, [
                  _createElementVNode("button", {
                    class: "ql-list",
                    value: "ordered",
                    type: "button"
                  }),
                  _createElementVNode("button", {
                    class: "ql-list",
                    value: "bullet",
                    type: "button"
                  })
                ], -1),
                _createElementVNode("span", { class: "ql-formats toolbarDivider" }, [
                  _createElementVNode("button", {
                    class: "ql-clean",
                    type: "button"
                  })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["placeholder", "onLoad", "onTextChange"])
          ]),
          _: 1
        }, 8, ["blocked"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              disabled: _ctx.loading || !_ctx.isDirty,
              label: _ctx.$t('Squeeze.General.Reset'),
              type: "button",
              icon: "mdi mdi-restore",
              class: "p-button-secondary",
              onClick: _ctx.resetSystemPrompt
            }, null, 8, ["disabled", "label", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              disabled: _ctx.loading || !_ctx.isDirty,
              label: _ctx.$t('Squeeze.General.Save'),
              type: "button",
              icon: "mdi mdi-content-save-outline",
              class: "p-button",
              onClick: _ctx.saveSystemPrompt
            }, null, 8, ["disabled", "label", "onClick"])
          ])
        ])
      ]))
}